import { html } from 'lit';
import { service } from '@src/service';
import { TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION } from '@src/service/tracker';
import { store } from '@src/store';
import { saveAndLoad, cancelEditMode } from '@src/store/consents';
import { ConsentGroup } from '@src/types/common';

export const viewTemplate = (
  consentGroup: ConsentGroup,
  editmodeActiveGroupInd: number,
  changesMade: boolean,
) => html`
          <div class="section">
            <tef-coms-consent-group
              .consentGroup=${consentGroup}
              .groupIndex=${editmodeActiveGroupInd}
               data-testid="group-${consentGroup.name.toLowerCase()}"
            ></tef-coms-consent-group>
          </div>
          <div class="section section-buttons">
            <div class="form-row form-row--buttons">
               <button
                  class="button button-border"
                  data-testid="button-cancel"
                  @click=${
  () => {
    store.dispatch(cancelEditMode());
    service.tracker.doTracking(
      TRACKER_EVENT_NAME_CANCEL_CHANGE_PERMISSION,
      {
        group:
                            consentGroup.name,
      },
    );
  }
}
               >
                  Abbrechen
               </button>
               <button
                 class="button button-default"
                 data-testid="button-save"
                .disabled=${!changesMade}
                data-disabled=${!changesMade}
                @click=${
  () => {
    store.dispatch(saveAndLoad());
  }
}
               >
                  Speichern
               </button>
            </div>
          </div>
          `;
